// @flow

export { default as cache } from 'universal/reducers/cache';
export { default as contentful } from 'client/reducers/contentful';
export { default as siteConfigs } from 'client/reducers/siteConfigs';
export { default as translations } from 'client/reducers/translations';
export { default as user } from 'client/reducers/user';
export const brand = (state: string = 'stride') => state;
